import { IFormConfiguration } from "../../../../hooks/useFilterConfig";

import { valuesToParams } from "../filters.functions";

import { CampaignBriefFilterFields } from "./campaign-brief-filters.component";
import { paramsToValues } from "./campaign-brief-filters.functions";
import { validation } from "./campaign-brief-filters.validation";

export const CampaignBriefFilter: IFormConfiguration = {
  Fields: CampaignBriefFilterFields,
  paramsToValues,
  validation,
  valuesToParams,
};
